import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { MapPin, ChevronLeft, ChevronRight } from "lucide-react";

export default function Step2Locatie({
  currentLoc, aantal, locatie,
  onLocChange, onAantalGroepenChange,
  onBack, onNextLoc, onGotoGroepen,
}) {
  return (
    <Card className="p-6 space-y-4" data-testid="wizard-step-2">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-medium flex items-center gap-2">
          <MapPin className="h-5 w-5" /> Locatie {currentLoc + 1} van {aantal}
        </h2>
        <Badge className="bg-neutral-100 text-neutral-700 border-none">{locatie.opvangtype}</Badge>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="col-span-2">
          <Label>Locatienaam *</Label>
          <Input value={locatie.name}
                 onChange={e => onLocChange({ name: e.target.value })}
                 data-testid={`wizard-loc-name-${currentLoc}`}
                 placeholder="Bijv. Hoofdvestiging Amsterdam" />
        </div>
        <div>
          <Label>Opvangtype</Label>
          <Select value={locatie.opvangtype}
                  onValueChange={v => onLocChange({ opvangtype: v })}>
            <SelectTrigger data-testid={`wizard-loc-type-${currentLoc}`}><SelectValue /></SelectTrigger>
            <SelectContent className="bg-white">
              <SelectItem value="KDV">KDV</SelectItem>
              <SelectItem value="BSO">BSO</SelectItem>
              <SelectItem value="gecombineerd">Gecombineerd</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>LRK-nummer *</Label>
          <Input value={locatie.lrk_number}
                 onChange={e => onLocChange({ lrk_number: e.target.value })}
                 data-testid={`wizard-loc-lrk-${currentLoc}`}
                 placeholder="8 cijfers" />
        </div>
        <div className="col-span-2">
          <Label>Bezoekadres</Label>
          <Input value={locatie.adres}
                 onChange={e => onLocChange({ adres: e.target.value })}
                 data-testid={`wizard-loc-adres-${currentLoc}`} />
        </div>
        <div>
          <Label>Postcode</Label>
          <Input value={locatie.postcode}
                 onChange={e => onLocChange({ postcode: e.target.value })} />
        </div>
        <div>
          <Label>Plaats</Label>
          <Input value={locatie.plaats}
                 onChange={e => onLocChange({ plaats: e.target.value })} />
        </div>
        <div>
          <Label>Telefoon</Label>
          <Input value={locatie.telefoon}
                 onChange={e => onLocChange({ telefoon: e.target.value })} />
        </div>
        <div>
          <Label>E-mail</Label>
          <Input value={locatie.email}
                 onChange={e => onLocChange({ email: e.target.value })} />
        </div>
        <div>
          <Label>Totale capaciteit</Label>
          <Input type="number" min={0} value={locatie.capaciteit}
                 onChange={e => onLocChange({ capaciteit: e.target.value })} />
        </div>
        <div>
          <Label>Aantal groepen op deze locatie</Label>
          <Input type="number" min={1} max={20}
                 value={locatie.aantal_groepen}
                 onChange={e => onAantalGroepenChange(e.target.value)}
                 data-testid={`wizard-loc-aantal-groepen-${currentLoc}`} />
        </div>
      </div>
      <div className="flex justify-between pt-4 border-t">
        <Button variant="outline" onClick={onBack} data-testid="wizard-back-2">
          <ChevronLeft className="h-4 w-4 mr-1" /> Vorige
        </Button>
        {currentLoc < aantal - 1 ? (
          <Button onClick={onNextLoc}
                  data-testid="wizard-next-loc"
                  style={{ background: "var(--sage)" }} className="text-white">
            Volgende locatie ({currentLoc + 2}/{aantal}) <ChevronRight className="h-4 w-4 ml-1" />
          </Button>
        ) : (
          <Button onClick={onGotoGroepen}
                  data-testid="wizard-goto-groups"
                  style={{ background: "var(--sage)" }} className="text-white">
            Naar groepen invoeren <ChevronRight className="h-4 w-4 ml-1" />
          </Button>
        )}
      </div>
    </Card>
  );
}
